import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyPagingComponent } from './paging.component';
import { SkyResourcesModule } from '../resources';


export class SkyPagingModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyPagingComponent
  ],
  imports: [
    CommonModule,
    SkyResourcesModule
  ],
  exports: [
    SkyPagingComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
